// extracted by mini-css-extract-plugin
export default {"continueButton":"add-to-cart-modal__continueButton__Xpd1i","commitText":"add-to-cart-modal__commitText__VCWch"};